/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".secondary[_ngcontent-%COMP%]{border-radius:2px;border:1px solid #4a8ee0;color:#4a8ee0}.primary[_ngcontent-%COMP%]{border-radius:2px;background-color:#4a8ee0;color:#fff}.simple[_ngcontent-%COMP%]{color:#4a8ee0}.disabled[_ngcontent-%COMP%]{border-color:#cfd8dc;color:#afbcc6;background-color:transparent}.disabled[_ngcontent-%COMP%]:hover{cursor:default}svg-icon[_ngcontent-%COMP%]{padding-right:6px}"];
export { styles as styles };
